export const DebounceConstants = {
  LOOK_UP: {
    DELAY: 10,
    OPTIONS: { onlyResolvesLast: true }
  }
}
